export default class Parametro {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.smtp = '';
        this.porta = 0;
        this.usuario = '';
        this.senha = '';
        this.email = '';
        this.assunto = '';
        this.usarSSL = true;
        this.juros = 0;
        this.multa = 0;
        this.smtp = '';
        this.instrucao1 = '';
        this.instrucao2 = '';
        this.instrucao3 = '';
        this.beneficiarioCampo01 = '';
        this.beneficiarioCampo02 = '';
        this.beneficiarioCampo03 = '';
        this.beneficiarioCampo04 = '';
        this.beneficiarioCampo05 = '';
        this.beneficiarioCampo06 = '';
        this.beneficiarioCampo07 = '';
        this.beneficiarioCampo08 = '';
        this.beneficiarioCampo09 = '';
        this.beneficiarioCampo10 = '';
        this.beneficiarioCampo11 = '';
        this.beneficiarioCampo12 = '';
        this.beneficiarioCampo13 = '';
        this.beneficiarioCampo14 = '';
        this.beneficiarioCampo15 = '';
        this.doadorCampo01 = '';
        this.doadorCampo02 = '';
        this.doadorCampo03 = '';
        this.doadorCampo04 = '';
        this.doadorCampo05 = '';
        this.pessoalCampo01 = '';
        this.pessoalCampo02 = '';
        this.pessoalCampo03 = '';
        this.certificado = '';
        this.certificadoNome = '';
        this.certificadoValidade = '';
        this.certificadoSenha = '';
        this.producaoNFse = false;
        this.textoNFSe = '';
        this.codigoServico = '';
        this.codigoTributacaoMunicipio = '';
        this.codigoNbs = '';
        this.doadorGrupoObrigatorio = '';
        this.validarContaContabilMovimentacao = false;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.smtp = model.smtp;
        this.porta = model.porta;
        this.usuario = model.usuario;
        this.senha = model.senha;
        this.email = model.email;
        this.assunto = model.assunto;
        this.usarSSL = model.usarSSL;
        this.juros = model.juros;
        this.multa = model.multa;
        this.instrucao1 = model.instrucao1;
        this.instrucao2 = model.instrucao2;
        this.instrucao3 = model.instrucao3;
        this.beneficiarioCampo01 = model.beneficiarioCampo01;
        this.beneficiarioCampo02 = model.beneficiarioCampo02;
        this.beneficiarioCampo03 = model.beneficiarioCampo03;
        this.beneficiarioCampo04 = model.beneficiarioCampo04;
        this.beneficiarioCampo05 = model.beneficiarioCampo05;
        this.beneficiarioCampo06 = model.beneficiarioCampo06;
        this.beneficiarioCampo07 = model.beneficiarioCampo07;
        this.beneficiarioCampo08 = model.beneficiarioCampo08;
        this.beneficiarioCampo09 = model.beneficiarioCampo09;
        this.beneficiarioCampo10 = model.beneficiarioCampo10;
        this.beneficiarioCampo11 = model.beneficiarioCampo11;
        this.beneficiarioCampo12 = model.beneficiarioCampo12;
        this.beneficiarioCampo13 = model.beneficiarioCampo13;
        this.beneficiarioCampo14 = model.beneficiarioCampo14;
        this.beneficiarioCampo15 = model.beneficiarioCampo15;
        this.doadorCampo01 = model.doadorCampo01;
        this.doadorCampo02 = model.doadorCampo02;
        this.doadorCampo03 = model.doadorCampo03;
        this.doadorCampo04 = model.doadorCampo04;
        this.doadorCampo05 = model.doadorCampo05;
        this.pessoalCampo01 = model.pessoalCampo01;
        this.pessoalCampo02 = model.pessoalCampo02;
        this.pessoalCampo03 = model.pessoalCampo03;
        this.certificado = model.certificado;
        this.certificadoNome = model.certificadoNome;
        this.certificadoValidade = model.certificadoValidade;
        this.certificadoSenha = model.certificadoSenha;
        this.producaoNFse = model.producaoNFse;
        this.textoNFSe = model.textoNFSe;
        this.codigoServico = model.codigoServico;
        this.codigoTributacaoMunicipio = model.codigoTributacaoMunicipio;
        this.codigoNbs = model.codigoNbs;
        this.doadorGrupoObrigatorio = model.doadorGrupoObrigatorio;
        this.validarContaContabilMovimentacao = !!model.validarContaContabilMovimentacao;
    }
}
